import { SYSLOG_SETTING } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';
import { httpservice } from '../services';
import { constants } from '../constant/constant';

const apiEndPoint = constants.ADMIN_URL;

export const getSyslogSettingList = () => (dispatch) => {
  const query = `${constants.API.SYSLOG_SETTINGS_LIST}`;

  dispatch({
    payload: [],
    type: SYSLOG_SETTING.DATA.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      const { rows = [], count = 0 } = response.data.response;

      const responseData = rows.map((data) => (
        {
          ...data,
          protocol: data.protocol.toUpperCase(),
          facility: `${data.facility.charAt(0).toUpperCase()}${data.facility.slice(1)}`,
          appName: `${data.appName.charAt(0).toUpperCase()}${data.appName.slice(1)}`,
          createdAt: dateFormat(data.createdAt),
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
        }
      ));

      dispatch({
        payload: { data: responseData, count },
        type: SYSLOG_SETTING.DATA.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SYSLOG_SETTING.DATA.ERROR,
      });
    });
};

export const doSyslogSettingCreate = (data) => httpservice()
  .post(`${apiEndPoint}${constants.API.SYSLOG_SETTING}`, data)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));

export const doSyslogSettingDelete = (Id) => {
  const endPointUri = `${constants.API.SYSLOG_SETTING}?id=${Id}`;
  return httpservice()
    .delete(endPointUri)
    .then((response) => ({ status: 1, data: response.data }))
    .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));
};

export const doSyslogSettingUpdate = (Id, data) => {
  const endPointUri = constants.API.SYSLOG_SETTING;
  // data.id = Id;
  return httpservice()
    .put(endPointUri, { ...data, id: Id })
    .then((response) => ({ status: 1, data: response.data }))
    .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));
};
